import { QueryClient } from "@tanstack/react-query";
import { isApiClientError } from "./ApiClientError";

const MAX_RETRIES = 3;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A 401 has already been through a token renewal attempt, retrying won't help.
      retry: (failureCount, error) =>
        !(isApiClientError(error) && error.status === 401) &&
        failureCount < MAX_RETRIES,
      staleTime: 5 * 1000,
    },
  },
});
